import { render, staticRenderFns } from "./ViewEmailAction.vue?vue&type=template&id=92914590&scoped=true&"
import script from "./ViewEmailAction.vue?vue&type=script&lang=js&"
export * from "./ViewEmailAction.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmailAction.vue?vue&type=style&index=0&id=92914590&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92914590",
  null
  
)

export default component.exports